import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, withHandlers, lifecycle } from 'recompose';
import { Field, reduxForm } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { addUserRequest, resetAddUserForm } from '../../redux/reducers/addUser';

import { commonStyles } from '../../styles/styles';
import AddUserEmailField from './AddUserEmailField';
import { validateAddUser } from './validate';

const AddUserForm = ({ classes, handleSubmit, handleSubmitAddUser, addUser }) => (
  <form onSubmit={handleSubmit(handleSubmitAddUser)} className={classes.formPopup}>
    {addUser.error && <Typography className={classes.formError}>{addUser.error}</Typography>}
    <Field name="Email" component={AddUserEmailField} />
    <Button
      variant="contained"
      className={`${classes.defaultButton} ${classes.button}`}
      type="submit"
    >
      ADD USER
    </Button>
  </form>
);

const styles = () => ({
  ...commonStyles,
  button: {
    width: 100,
  },
});

const mapStateToProps = state => ({
  form: state.form,
  addUser: state.addUserReducer,
});

const mapDispatchToProps = dispatch => ({
  addUserRequest: () => dispatch(addUserRequest()),
  resetAddUserForm: () => dispatch(resetAddUserForm()),
});

export default compose(
  reduxForm({
    form: 'addUserForm',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  lifecycle({
    componentWillUnmount() {
      this.props.resetAddUserForm();
    },
  }),
  withHandlers({
    handleSubmitAddUser: props => values => {
      props.resetAddUserForm();
      validateAddUser(values);
      props.addUserRequest();
    },
  }),
  withStyles(styles),
)(AddUserForm);

AddUserForm.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  handleSubmitAddUser: PropTypes.func,
  addUser: PropTypes.instanceOf(Object),
};



// WEBPACK FOOTER //
// ./src/Components/Form/AddUserForm.jsx